import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@mui/styles';
import {useSelector, useDispatch} from "react-redux";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

/*
const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];
 */

export default function BasicTable() {
  // const [rows, setRows] = useState([])
  const rows = []
  const stores = useSelector((state) => state.stores.stores)
  const storeIds = stores.allIds
  const storesById = stores.byId
  storeIds.forEach((id) => {
    rows.push(storesById[id])
  })
  // setRows()
  const theme = useTheme()
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{ backgroundColor: theme.palette.secondary.main, color:'white' }}>
          <TableRow style={{color:'white'}}>
            <TableCell style={{color:'white'}}>ID</TableCell>
            <TableCell style={{color:'white'}}>Name</TableCell>
            <TableCell style={{color:'white'}}>Address</TableCell>
            <TableCell style={{color:'white'}}>Delivery Dist.</TableCell>
            <TableCell style={{color:'white'}} align="center">Hours</TableCell>
            <TableCell style={{color:'white'}} align="center">Rep</TableCell>
            <TableCell style={{color:'white'}} align="center"> Orders</TableCell>
            <TableCell style={{color:'white'}} align="right">{null}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                {row.id}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell>{row.address}</TableCell>
              <TableCell>{row.delivery_range}</TableCell>
              <TableCell align="center">
                <Button variant="contained" disableElevation color="redorange" style={{textTransform: 'none'}} sx={{width:'75%'}} size="small">
                  c
                </Button>
              </TableCell>
              <TableCell align="center">
                <Button variant="contained" disableElevation color="redorange" style={{textTransform: 'none'}} sx={{width:'75%'}} size="small">
                  c
                </Button>
              </TableCell>
              <TableCell align="center">
                <Button variant="contained" disableElevation color="redorange" style={{textTransform: 'none'}} sx={{width:'75%'}} size="small">
                  View Orders
                </Button>
              </TableCell>
              <TableCell align="right">
                <IconButton>
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
